import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { hrAPI } from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { ChevronDown, Users2 } from 'lucide-react';

function flatten(nodes, depth, out) {
  for (const n of nodes) {
    out.push({ id: n.id, name: n.name, emp_code: n.emp_code, depth, count: (n.reports || []).length });
    if (n.reports && n.reports.length) flatten(n.reports, depth + 1, out);
  }
  return out;
}

export default function ReportingTreePage() {
  const navigate = useNavigate();
  const [tree, setTree] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    hrAPI.reportingTree().then(r => setTree(r.data.tree || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const flat = flatten(tree, 0, []);

  return (
    <div className="space-y-5" data-testid="hr-reporting-tree-page">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-[#0F172A] flex items-center gap-2"><Users2 className="w-6 h-6 text-pink-600" /> Reporting Structure</h1>
        <p className="text-sm text-slate-500 mt-0.5">Organisation tree built from each employee's immediate supervisor</p>
      </div>
      <Card className="border border-slate-200 shadow-none">
        <CardContent className="p-3">
          {loading ? (
            <p className="text-sm text-slate-400 py-6 text-center">Loading...</p>
          ) : flat.length === 0 ? (
            <p className="text-sm text-slate-400 py-6 text-center">No supervisor links set yet. Assign supervisors on employee profiles.</p>
          ) : (
            <div>
              {flat.map(node => (
                <button
                  key={node.id}
                  onClick={() => navigate(`/hr/employees/${node.id}`)}
                  className="flex items-center gap-2 py-1.5 px-2 rounded hover:bg-pink-50 text-sm w-full text-left"
                  style={{ paddingLeft: `${node.depth * 22 + 8}px` }}
                  data-testid={`tree-node-${node.id}`}
                >
                  {node.count > 0 ? <ChevronDown className="w-3.5 h-3.5 text-slate-400" /> : <span className="w-3.5" />}
                  <span className="w-6 h-6 rounded-full bg-pink-100 text-pink-700 flex items-center justify-center text-[10px] font-semibold">{node.name ? node.name.charAt(0).toUpperCase() : '?'}</span>
                  <span className="font-medium">{node.name}</span>
                  {node.emp_code ? <span className="text-[10px] text-slate-400 font-mono">{node.emp_code}</span> : null}
                  {node.count > 0 ? <span className="text-[10px] text-slate-400">({node.count})</span> : null}
                </button>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
